module.exports = __webpack_public_path__ + "img/spotify.8aa80b1a.png";